import * as React from "react";
import { SVGProps } from "react";
const SvgArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.82 7.21a1 1 0 1 1 1.228 1.579c-2.798 2.179-5.04 4.263-6.682 6.215H24.5a1 1 0 0 1 .117 1.993l-.117.007H9.372c1.643 1.95 3.882 4.032 6.677 6.207a1 1 0 1 1-1.228 1.578c-3.505-2.727-6.191-5.341-7.983-7.767a1.712 1.712 0 0 1 0-2.044c1.79-2.425 4.476-5.04 7.982-7.767V7.21Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArrowLeft;
